const $ = window.jQuery;

export default class Layout {
    constructor($container, $items) {
        this.$container = $container;
        this.$items = $items;

        if (!this.$container.length || !this.$items.length) {
            console.warn("R Layout: wrap or items do not exist");
            return;
        }

        if (!globals.booleans.isLoggedIn) {
            return;
        }

        this.initEditMode();
        this.fit();
        this.addHelperGrid();

        $(window).resize(() => this.fit());
        $(document).scroll(() => this.fit());
    }

    fit() {
        // this.updateDraggableContainment();
    }

    addHelperGrid() {
        let $grid = $(`<div class="helper-grid"></div>`);

        for (let i = 0; i < 12; i++) {
            $grid.append('<span class="helper-grid_segment"></span>');
        }
        this.$container.prepend($grid);
    }

    initEditMode() {
        var self = this;

        $("#container").addClass("is-edit-mode");

        if (globals.booleans.isLoggedIn) {
            this.$items.each(function (index) {
                var $el = $(this);

                // do not instanciate twice
                if ($el.hasClass("ui-draggable")) {
                    return true;
                }

                if (index === 1) {
                    // $(this).addClass('is-debug');
                }

                $el.find(".layout-item_index").remove();
                $el.prepend(
                    `<span class="layout-item_index">${index + 1}</span>`,
                );
                $el.find(".layout-item-iframe-mask").remove();
                $el.find("iframe").after(
                    '<div class="layout-item-iframe-mask"></div>',
                );

                // $el.draggable({
                //   scroll: false,
                //   // containment: self.getDraggableContainment( $el ),
                //   start: function() {
                //     self.beforeEditLayout( $el );
                //   },
                //   stop: function(e, ui) {
                //     self.afterEditLayout( $el );
                //   }
                // });
            });

            this.$items.each(function () {
                let $el = $(this);
                let ratio = $el.width() / $el.height();

                $el.resizable({
                    autoHide: true,
                    handles: "e, w",
                    start: function () {
                        self.beforeEditLayout($el);
                    },
                    // // aspectRatio: ratio,
                    stop: function (e, ui) {
                        self.afterEditLayout($el);
                    },
                });
            });
        }

        $(".ui-icon-gripsmall-diagonal-se").removeClass(
            "ui-icon ui-icon-gripsmall-diagonal-se",
        );
    }

    beforeEditLayout($el) {
        this.$container.addClass("show-helper-grid");
    }

    afterEditLayout($el) {
        this.convertAndSavePosition($el);
        this.fit();
        this.$container.removeClass("show-helper-grid");
        $el.trigger("layout:updated");
    }

    updateDraggableContainment() {
        this.$items.each((index, el) => {
            var $el = $(el);
            if (!$el.is(".ui-draggable")) {
                return true;
            }
            $el.draggable(
                "option",
                "containment",
                this.getDraggableContainment($el),
            );
        });
    }

    getDraggableContainment($el) {
        let $container = this.$container;

        let $parent = $el.parents(".layout-item-wrap:first");
        let elementOffset = this.getElementOffset($el);

        let tolerance = 5;

        let $prevElement = $parent
            .prev(".layout-item-wrap")
            .find(".layout-item");
        let prevElementOffset = this.getElementOffset($prevElement);

        let topOffset = $container.offset().top - elementOffset.top - tolerance;
        if ($prevElement.length) {
            topOffset =
                $prevElement.offset().top -
                (elementOffset.top + $el.outerHeight() / 2);
        }

        let containment = [
            $container.offset().left - elementOffset.left - tolerance,
            topOffset,
            $container.offset().left +
                $container.width() -
                elementOffset.left -
                $el.outerWidth() +
                tolerance,
            3000,
        ];

        return containment;
    }

    getElementOffset($el) {
        if (!$el.length) {
            return {
                top: 0,
                left: 0,
                relativeTop: 0,
                relativeLeft: 0,
            };
        }

        var $parent = $el.parents(".layout-item-wrap:first");

        return {
            top: $el.offset().top - $parent.offset().top,
            left: $el.offset().left - $parent.offset().left,
            relativeTop: $el.offset().top,
            relativeLeft: $el.offset().left,
        };
    }

    convertAndSavePosition($el) {
        var $container = $el.parents(".layout-item-wrap:first");

        var $post = $el.parents(".single-post:first");
        var offsetTop = $el.offset().top - $container.offset().top;
        var offsetLeft = $el.offset().left - $container.offset().left;
        var offsetRight =
            ($el.offset().left +
                $el.width() -
                ($container.offset().left + $container.width())) *
            -1;
        var offsetBottom =
            $container.height() - ($el.position().top + $el.height());

        var elementId = $el.attr("data-element-id");
        var fieldId = $el.attr("data-acf-id");

        var newWidth = parseFloat(
            ($el.outerWidth() / $container.width()) * 100,
        ).toFixed(2);
        var newMarginTop = parseFloat(
            (offsetTop / $container.width()) * 100,
        ).toFixed(2);
        var newMarginLeft = parseFloat(
            (offsetLeft / $container.width()) * 100,
        ).toFixed(2);

        var newCSS = {
            // 'margin-top': newMarginTop + '%',
            // 'margin-left': newMarginLeft + '%',
            width: newWidth + "%",
        };

        $el.removeAttr("style").css(newCSS);

        // if( globals.booleans.isLoggedIn ) {
        this.saveCSS(elementId, fieldId, newCSS);
        // }
    }

    saveCSS(elementId, fieldId, styles) {
        var self = this;

        $.ajax({
            method: "post",
            url: globals.ajaxUrl,
            data: {
                action: "update_custom_layout",

                element_id: elementId,
                field_id: fieldId,
                styles: styles,
            },
            success: function (response) {
                self.showNotification(response);
            },
        });
    }

    showNotification(response) {
        // console.log( 'Layout updated:', response );

        if (undefined !== this.notificationsTimeout) {
            clearTimeout(this.notificationsTimeout);
        }
        $(".notifications").addClass("is-active");
        this.notificationsTimeout = setTimeout(function () {
            $(".notifications").removeClass("is-active");
        }, 1500);
    }
}

// $(document).ready(function() {
//   new Layout();
// })
